/**
 * Versão do build do front (SA-1416). O SHA do commit entra no build como
 * `VITE_APP_VERSION` e também vira `/version.json`; a aba compara as duas para
 * saber se está rodando um código que não é mais o que está no ar.
 */
export const APP_VERSION_HEADER = "x-app-version";

export const BUILD_APP_VERSION: string =
  import.meta.env.VITE_APP_VERSION || "dev";

/** Dev local e testes não têm `version.json`: não há o que comparar. */
export const isVersionCheckEnabled = (version: string) => version !== "dev";

/**
 * Versão que o front está servindo agora, ou `null` em qualquer falha (rede,
 * 404, HTML do fallback do nginx). Nunca vira erro na tela.
 */
export async function fetchDeployedVersion(): Promise<string | null> {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });
    if (!response.ok) return null;
    const body = (await response.json()) as { version?: unknown };
    return typeof body.version === "string" && body.version
      ? body.version
      : null;
  } catch {
    return null;
  }
}

const RELOADED_FOR_KEY = "app-version:reloaded-for";

/**
 * Esta aba já recarregou para chegar a `version` e continuou no bundle antigo
 * (algo na frente do nginx serviu o index.html velho). Sem esta trava, o aviso
 * voltaria e cada troca de seção recarregaria de novo.
 */
export function alreadyReloadedFor(version: string): boolean {
  try {
    return window.sessionStorage.getItem(RELOADED_FOR_KEY) === version;
  } catch {
    return false;
  }
}

/** Recarrega para buscar o bundle de `targetVersion`, lembrando a tentativa. */
export function reloadPage(targetVersion?: string | null) {
  if (targetVersion) {
    try {
      window.sessionStorage.setItem(RELOADED_FOR_KEY, targetVersion);
    } catch {
      // Sem storage (modo restrito): recarrega mesmo assim, só sem a trava.
    }
  }
  window.location.reload();
}
